import { fetchWatchlists, getWatchlist } from '../../services/apis/watchlist';
import { setWatchlist, setWatchlists, Watchlist } from '../../reducer/watchList.reducer';
import commonActions from '../../actions/common.actions';
import { getSecurityKey } from '../../util/security';

import { Watchlist_ShareType, Watchlist_Type, Watchlist_WatchlistItem, Watchlist_WatchlistItem_Type } from '../../proto/generated/watchlist';
import { deepClone } from '@mui/x-data-grid/utils/utils';
import store from '../../store';

export const updateWatchlist = async (
    dispatch: any,
    selectedWatchlistId: string,
    dataUpdatingRef: React.MutableRefObject<boolean>,
    setLoading: (value: boolean) => void,
    setDefault?: boolean,
    fetchSelected?: boolean,
    fetchList = false
) => {
    if (dataUpdatingRef) {
        dataUpdatingRef.current = true;
    }
    const activeWatchlistId = store.getState().commonStore.watchlistId; 
    const processWatchlistItems = (items: Watchlist_WatchlistItem[]) => {
        return items
            .map((watchlistItem) => {
                let itemId = '';
                const { type, security, securityExpression, sectionName } = watchlistItem;

                if (type === Watchlist_WatchlistItem_Type.SECURITY && security) {
                    itemId = getSecurityKey(security.exchange, security.code);
                } else if (type === Watchlist_WatchlistItem_Type.EXPRESSION && securityExpression) {
                    itemId = securityExpression.expression;
                } else if (type === Watchlist_WatchlistItem_Type.SECTION && sectionName !== undefined) {
                    itemId = sectionName;
                }

                return { id: itemId, item: watchlistItem };
            })
            .filter((watchlistItem) => {
                const { type, security, securityExpression, sectionName } = watchlistItem.item;
                return (
                    watchlistItem.id &&
                    ((type === Watchlist_WatchlistItem_Type.SECURITY && security) ||
                        (type === Watchlist_WatchlistItem_Type.EXPRESSION && securityExpression && !securityExpression.expired && securityExpression.securities.length > 0) ||
                        (type === Watchlist_WatchlistItem_Type.SECTION && sectionName !== undefined))
                );
            });
    };

    try {
        // Case 1: Fetch and update a SINGLE watchlist
        if (fetchSelected && !fetchList) {
            const updatedWatchlist = await getWatchlist({ watchlistId: selectedWatchlistId });
            const currentState = store.getState().watchListStore.watchlists;
            const newWatchlists = {
                ...currentState, 
                [updatedWatchlist.id]: { 
                    ...updatedWatchlist,
                    type: Array.isArray(updatedWatchlist.type) ? updatedWatchlist.type : [updatedWatchlist.type],
                    watchlistItems: processWatchlistItems(updatedWatchlist.watchlistItems),
                },
            };
            
            dispatch(setWatchlists(newWatchlists));
        } 
        // Case 2: Fetch and replace the ENTIRE list of watchlists
        else {
            const response = await fetchWatchlists({ dispatch });
            if (!response) {
                console.log('error fetching config data');
                return;
            }
            const data = deepClone(response);
            const ids = data.watchlists.map((wl) => wl.id);
            if (data.watchlists.length < 1) {
                commonActions.dispatchWatchlistId(dispatch, undefined);
            } else if (setDefault || !ids.includes(activeWatchlistId)) {
                const newDefaultWatchlist = data.watchlists.find(w => 
                    w.type !== Watchlist_Type.REFERENCE || (w.type === Watchlist_Type.REFERENCE && w.shareId)
                );
                if (newDefaultWatchlist) {
                    commonActions.dispatchWatchlistId(dispatch, newDefaultWatchlist.id);
                } else {
                    commonActions.dispatchWatchlistId(dispatch, undefined);
                }
            }
            
            const newWatchlists: Record<string, Watchlist> = {};
            data.watchlists.forEach((userWatchlist) => {
                newWatchlists[userWatchlist.id] = {
                    ...userWatchlist,
                    type: Array.isArray(userWatchlist.type) ? userWatchlist.type : [userWatchlist.type],
                    watchlistItems: processWatchlistItems(userWatchlist.watchlistItems),
                };
            });
            
            dispatch(setWatchlists(newWatchlists));
        }

    } catch (e) {
        console.error('Error updating watchlists', e);
    } finally {
        if (dataUpdatingRef) {
            dataUpdatingRef.current = false;
        }
        setLoading(false);
    }
};
export const isCommunityOrReferenceType = (watchlist: Watchlist): boolean => {
	return (
		watchlist?.type?.includes(Watchlist_Type.REFERENCE) &&
		watchlist?.shareType === Watchlist_ShareType.COMMUNITY
	);
};

export const updateWatchlistInState = async (watchlistId: string, dispatch: any,) => {
	try {
		const userWatchlist = await getWatchlist({ watchlistId: watchlistId });
		const updatedItems = userWatchlist.watchlistItems
			.map((watchlistItem) => {
				let itemId = '';
				const { type, security, securityExpression, sectionName } = watchlistItem;

				if (type === Watchlist_WatchlistItem_Type.SECURITY && security) {
					itemId = getSecurityKey(security.exchange, security.code);
				} else if (type === Watchlist_WatchlistItem_Type.EXPRESSION && securityExpression) {
					itemId = securityExpression.expression;
				} else if (type === Watchlist_WatchlistItem_Type.SECTION && sectionName !== undefined) {
					itemId = sectionName;
				}

				return { id: itemId, item: watchlistItem };
			})
			.filter(({ id, item }) => {
				const { type, security, securityExpression, sectionName } = item;
				return (
					id &&
					(
						(type === Watchlist_WatchlistItem_Type.SECURITY && security) ||
						(type === Watchlist_WatchlistItem_Type.EXPRESSION &&
							securityExpression &&
							!securityExpression.expired &&
							securityExpression.securities.length > 0) ||
						(type === Watchlist_WatchlistItem_Type.SECTION && sectionName !== undefined)
					)
				);
			});
			const watchlistPayload: Watchlist = {
				...userWatchlist,
				type: Array.isArray(userWatchlist.type)
					? userWatchlist.type
					: [userWatchlist.type],
				watchlistItems: updatedItems,
			};
            dispatch(setWatchlist(watchlistPayload));
	} catch (error) {
		console.error("Error fetching watchlist:", error);
	}
};

